import * as React from "react";
import { Route, RouteComponentProps, withRouter } from "react-router-dom";
import * as devices from "../services/devices";
import * as settingsService from "../services/settings";
import * as square from "../services/square";
import * as transactions from "../services/transactions";
import socketIO from "../socket.io";
import withRoot from "../withRoot";
import Ad from "./Ad";
import "./App.css";
import HeaderBar from "./HeaderBar";
import Settings from "./Settings";
import Transaction from "./Transaction";
import TransactionResult from "./TransactionResult";

interface IAppProps extends RouteComponentProps {
  busy: boolean;
  socket: Promise<SocketIOClient.Socket>;
}

interface IAppState {
  busy: boolean;
  finalizing: boolean;
  settings: settingsService.IDeviceSettings | undefined;
  socket: SocketIOClient.Socket | undefined;
}

class App extends React.Component<IAppProps, IAppState> {
  public constructor(props: IAppProps) {
    super(props);

    this.state = {
      settings: undefined,
      socket: undefined,
      busy: false,
      finalizing: false
    };

    this.handleNewTransaction = this.handleNewTransaction.bind(this);
    this.finalizeTransaction = this.finalizeTransaction.bind(this);
    this.reset = this.reset.bind(this);
  }

  public async handleNewTransaction(transaction: { id: string }) {
    if (this.state.busy) {
      this.state.socket!.emit("device-busy", `Busy processing another transaction.`);
    } else {
      this.setState({ busy: true }, () => {
        this.state.socket!.emit("transaction-accepted", transaction.id);
        transactions.setCurrentTransaction(transaction.id);
        this.props.history.push("/transaction");
      });
    }
  }

  public async finalizeTransaction() {
    if (this.state.finalizing) {
      return;
    }

    this.setState({ finalizing: true }, async () => {
      const currentTransactionId = transactions.getCurrentTransactionId();

      if (currentTransactionId) {
        const { id } = settingsService.getSettings()!;
        const device = await devices.getDevice(id);

        const url = new URL(window.location.href);

        const { transactionId: squareId } =
          device.os === "iOS" ? square.getiOSTransactionInfo(url) : square.getAndroidTransactionInfo(url);

        await transactions.finalizeTransaction(id, currentTransactionId!, squareId);
      }

      this.setState({ busy: false, finalizing: false }, () => {
        transactions.clearCurrentTransaction();
        this.props.history.push("/");
      });
    });
  }

  public async reset() {
    this.state.socket!.disconnect();
    this.setState({ busy: false, finalizing: false, socket: await socketIO(true) }, () => {
      transactions.clearCurrentTransaction();
      this.props.history.push("/");
    });
  }

  public async componentDidMount() {
    this.setState(
      {
        busy: !!transactions.getCurrentTransactionId(),
        socket: await this.props.socket,
        settings: settingsService.getSettings()
      },
      () => {
        this.state.socket!.on("new-transaction", this.handleNewTransaction);
      }
    );
  }

  public render() {
    return (
      <div className="App">
        {/* <HeaderBar reset={this.reset} /> */}
        <div className="container">
          <Route
            path="/"
            exact={true}
            render={props => {
              const kioskUrl = (this.state.settings && this.state.settings.kioskUrl) || "https://hero.travel/kiosk-01/";
              return <Ad url={kioskUrl} />;
            }}
          />
          <Route path="/settings" component={Settings} />
          <Route
            path="/transaction"
            exact={true}
            render={props => (
              <Transaction
                {...props}
                transactionId={transactions.getCurrentTransactionId() || ""}
                socket={this.props.socket}
              />
            )}
          />
          <Route
            path="/transaction-result"
            exact={true}
            render={props => (
              <TransactionResult
                handleFinalizeTransaction={this.finalizeTransaction}
                transactionId={transactions.getCurrentTransactionId() || ""}
              />
            )}
          />
        </div>
      </div>
    );
  }
}
export default withRoot(withRouter(App));



// WEBPACK FOOTER //
// ./src/components/App.tsx